import { render, staticRenderFns } from "./B2B.vue?vue&type=template&id=54cd8a48&scoped=true&"
import script from "./B2B.vue?vue&type=script&lang=js&"
export * from "./B2B.vue?vue&type=script&lang=js&"
import style0 from "./B2B.vue?vue&type=style&index=0&id=54cd8a48&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cd8a48",
  null
  
)

export default component.exports